module.exports = __webpack_public_path__ + "img/21ne.c1b5a37b.svg";